<lms-modal size="medium">
  <div class="gl-popup__close" (click)="popupClose()">
    <span class="glicon-close"></span>
  </div>
  <div
    class="gl-popup__title"
    [innerHTML]="'users.confirmRoleChange' | translate : '{ user:\'' + user.email + '\'}'"
  ></div>
  <div
    class="gl-popup__text"
    *ngIf="user.role !== 'demo' && user.role !== 'student'"
    [innerHTML]="'users.roleChangeMessage' | translate : '{ currentRole:\'' + currentRole + '\'}'"
  ></div>
  <div class="gl-popup__text" *ngIf="user.role === 'demo'" [innerHtml]="'users.demoChangeMessage' | translate"></div>
  <div class="margin-top">
    <lms-dynamic-form
      [action]="'students.change-role'"
      [questions]="questions"
      (submit)="changeRole($event)"
      [options]="{ disableCard: true }"
    >
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="popupClose()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
